import { style } from "@vanilla-extract/css";

import { zIndexes } from "../../theme/zIndex";

export const appStyle = style({
  display: "contents",
});

export const portalStyle = style({
  position: "fixed",
  top: 0,
  left: 0,
  pointerEvents: "none",
  width: "100vw",
  minHeight: "100vh",
  maxHeight: "100%",
  overflow: "hidden",
  zIndex: zIndexes.portal,
});
